const ComponentLoader = () => {
  return <div className="spinner-grow" role="status" />;
};

export default ComponentLoader;
